import styled from "@emotion/styled/macro";
import { VaultEraseIcon } from "../../assets/icons";
import { flexCenter } from "../../../../common/styles/combos.styles";

export const EraseIconWhite = styled(VaultEraseIcon)`
    path {
        stroke: white;
    }
`;

export const VaultDeleteModalBodyContent = styled.div`
    padding: 7px 0px 62px 0px;
    border-bottom: 1px solid var(--Gray-3, #DDE3EB);
`;

export const VaultDeleteModalBody = styled.div`
    display: flex;
    width: 520px;
    padding: 8px 40px 0px 40px;
    flex-direction: column;
    align-items: center;
    gap: 8px;
`;

export const VaultDeleteModalMainText = styled.div`
    color: var(--Dark-Gray-1, #1A1B1D);
    text-align: center;
    font-size: 15px;
    font-style: normal;
    font-weight: 500;
    line-height: normal;
`;

export const VaultDeleteModalSecondaryText = styled.div`
    color: var(--Dark-Gray-2, #585D66);
    text-align: center;
    font-size: 13px;
    font-style: normal;
    font-weight: 450;
    line-height: normal;
`;
export const VaultSuccessModalFooter = styled.div`
  ${flexCenter};
  justify-content: space-between;
  padding: 16px 24px;
`;